import { render, staticRenderFns } from "./MinePane.vue?vue&type=template&id=076b2032&scoped=true"
import script from "./MinePane.vue?vue&type=script&lang=js"
export * from "./MinePane.vue?vue&type=script&lang=js"
import style0 from "./MinePane.vue?vue&type=style&index=0&id=076b2032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076b2032",
  null
  
)

export default component.exports